import React from 'react';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import getCarImages from '@/features/cars/helpers/getCarImages';
import getCarTitle from '@/features/cars/helpers/getCarTitle';
import getCarVideos from '@/features/cars/helpers/getCarVideos';
import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';

import { CardImageProps } from './CardImage.types';

function CardImage({ data, isLoading = false }: CardImageProps) {
  const media = useAppSelector(rootSelectors.config.mediaSelector);

  if (isLoading) {
    return <CarCard.ImageSkeleton />;
  }

  if (!data) {
    return null;
  }

  const images = getCarImages(data, {
    view: 'card',
    media,
  });
  const videos = getCarVideos(data);
  const title = getCarTitle(data);

  if (images && images.length) {
    return <CarCard.Image showNav images={images} videos={videos} />;
  }

  return <CarCard.Image images={[{ title }]} />;
}

export default CardImage;
